import EmitterManager from './EmitterManager';
import { RESIZE, RESIZE_UPDATE, LOAD, DOM_CONTENT_LOADED } from '../core/Events';

const isMobileOrTablet =
  navigator.userAgent.match(/Android/i) !== null ||
  navigator.userAgent.match(/webOS/i) !== null ||
  navigator.userAgent.match(/iPhone/i) !== null ||
  navigator.userAgent.match(/iPod/i) !== null ||
  navigator.userAgent.match(/iPad/i) !== null ||
  navigator.userAgent.match(/windows phone/i) !== null ||
  navigator.userAgent.match(/BlackBerry/i) !== null
    ? true
    : false;

const defaults = {
  autoEnable: true,
};

class ResizeManager {
  constructor(options) {
    this.options = Object.assign({}, defaults, options);
    this.bind();

    this.width = window.innerWidth;
    this.height = window.innerHeight;

    if (this.options.autoEnable) {
      this.enable();
    }
  }

  bind() {
    this.handleResize = this.handleResize.bind(this);
    this.emitResizeEvent = this.emitResizeEvent.bind(this);
  }

  enable() {
    this.events(true);
  }

  disable() {
    this.events(false);
  }

  events(listen = false) {
    let method = null;

    method = listen === false ? 'removeEventListener' : 'addEventListener';
    window[method](RESIZE, this.handleResize);
    window[method](LOAD, this.handleResize);
    window[method](DOM_CONTENT_LOADED, this.handleResize);

    method = listen === false ? 'removeListener' : 'addListener';
    EmitterManager[method](RESIZE_UPDATE, this.handleResize);
  }

  handleResize(event) {
    const w = window.innerWidth;
    const h = window.innerHeight;

    if (
      isMobileOrTablet &&
      event &&
      event.type === 'resize' &&
      this.width === w &&
      h > this.height
    ) {
      return false;
    }

    this.width = w;
    this.height = h;

    if (this.resizeTicking !== true) {
      requestAnimationFrame(this.emitResizeEvent);
    }

    this.resizeTicking = true;
  }

  emitResizeEvent() {
    const htmlStyle = window.getComputedStyle(document.documentElement);
    this.scrollPaddingTop = parseInt(htmlStyle.scrollPaddingTop, 10);
    document.documentElement.style.setProperty('--vh', `${this.height * 0.01}px`);

    EmitterManager.emit(RESIZE, this.width, this.height);

    this.resizeTicking = false;
  }
}

export default new ResizeManager();
